import React, { useState, useEffect } from "react";
import "./FakeNotification.scss";

const amountOptions = [
  "$500", "$600", "$700", "$800", "$900",
  "$1,000", "$2,000", "$3,000", "$4,000", "$5,000"
];

const getRandomId = () => Math.floor(Math.random() * 9000) + 1000; // 1000-9999
const getRandomAmount = () => amountOptions[Math.floor(Math.random() * amountOptions.length)];
const getRandomTime = () => Math.floor(Math.random() * 15) + 1; // 1-15 minutes ago

const FakeNotification = () => {
  const [visible, setVisible] = useState(false);
  const [notification, setNotification] = useState({
    id: getRandomId(),
    amount: getRandomAmount(),
    time: getRandomTime()
  });

  const generateNewNotification = () => {
    setNotification({
      id: getRandomId(),
      amount: getRandomAmount(),
      time: getRandomTime()
    });
    setVisible(true);

    // Hide after 5 seconds
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  };

  useEffect(() => {
    // Show first notification after 3 seconds
    const initialTimer = setTimeout(() => {
      generateNewNotification();
    }, 3000);

    // Show new notification every 15-30 seconds
    const interval = setInterval(() => {
      const randomDelay = Math.floor(Math.random() * 5000) + 5000; // 15-30 seconds
      setTimeout(() => {
        generateNewNotification();
      }, randomDelay);
    }, 10000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className={`fake-notification ${visible ? "show" : ""}`}>
      <div className="notification-icon">
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.5559 8.11122C28.6923 8.11122 33.667 13.0858 33.667 19.2223V24.1992C33.667 25.2877 34.0663 26.3383 34.7894 27.1519L37.6243 30.3412C39.5352 32.4908 38.0092 35.889 35.133 35.889H9.97858C7.10242 35.889 5.5764 32.4908 7.48722 30.3412L10.322 27.1519C11.0452 26.3383 11.4446 25.2877 11.4446 24.1992L11.4447 19.2223C11.4447 13.0858 16.4193 8.11122 22.5559 8.11122ZM22.5559 8.11122V2.55566M2.55566 20.3337C2.55566 13.3994 6.08462 7.28933 11.4446 3.70149M42.5557 20.3337C42.5557 13.3994 39.0268 7.28933 33.6668 3.70149M20.3334 42.5557H24.7779" stroke="#FBAA34" strokeWidth="5.11111" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="31.0557" cy="11.5557" r="4.5" fill="#FF090F" />
        </svg>
      </div>
      <div className="notification-content">
        <div className="notification-title">
          Loan ID #{notification.id} just funded
        </div>
        <div className="notification-detail">
          for <span className="amount">{notification.amount}</span> • {notification.time}m ago
        </div>
      </div>
    </div>
  );
};

export default FakeNotification;
